module.exports = function(app) {
	"use strict";
    app
    .directive('highlightedChar',highlightedChar);
    highlightedChar.$inject = [];
    function highlightedChar() {
        return {
            restrict: 'E',
            scope: {
                text: '=',
                decode:'=',
                limitCharacter:"=",
                limitCharacterMin:"="
            },
            replace:true,
            template:'<div class="highlighted-text-inner"><span ng-class="{\'danger-color\':index<25}">{{textSubceed}}</span><span ng-if="textExceed.length>0" class="danger-color">{{textExceed}}</span></div>',
            link: function(scope) {
                scope.textSubceed='';
                scope.textExceed = '';
                scope.index = 0;
                if(!scope.limitCharacterMin) {
                    scope.limitCharacterMin = 0
                }
                var textArray;
                scope.$watch(function () {
                    return scope.text;
                }, function(newValue) {
                    if (newValue === null || newValue === undefined) return;
                    scope.textSubceed=''
                    scope.textExceed = ''
                    textArray = newValue.split('');
                    scope.index = 0;
                    for (var i = 0; i<textArray.length;i++) {
                        if(textArray[i] == '"' && scope.decode) {
                            scope.index +=6
                        } else {
                            scope.index ++
                        }
                        if(scope.index<=scope.limitCharacter) {
                            scope.textSubceed += textArray[i]
                        } else {
                            scope.textExceed += textArray[i]
                        }
                    }
                })
            }
        }
    }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/highligtedCharacterDirective.js
// module id = 440
// module chunks = 0